import React, { useEffect, useState } from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAppSelector } from '@/store/hooks';


export interface YoutubeChannel {
    _id: string;
    channelName: string;
    channelPhoto: string | null;
    subscribers: number;
    link: string;
    status: 'active' | 'inactive' | '';
    createdAt: string;
    updatedAt: string;
}
const ProductList: React.FC = () => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL;

    const [ProductData, setProductData] = useState<YoutubeChannel[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const { token } = useAppSelector((state) => state.auth);
    const navigate = useNavigate();
    useEffect(() => {
        fetch(`${baseUrl}/products`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .then(data => {
                console.log("Fetched Product Data:", data.data);
                if (Array.isArray(data?.data)) {
                    setProductData(data.data);
                }
            })
            .catch(err => {
                console.error("Failed to fetch slider data:", err);
            });
    }, []);

    console.log("Fetched YouTube Channel Data:", ProductData);

    const filteredData = ProductData.filter(item =>
        item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.link?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    const startIndex = (currentPage - 1) * entriesPerPage;
    const endIndex = startIndex + entriesPerPage;
    const currentData = filteredData.slice(startIndex, endIndex);

    const handleStatusToggle = (id: number) => {
        // Handle status toggle logic
    };

    const handleDelete = async (id: string) => {
        try {
            await axios.delete(`${baseUrl}/products/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // ✅ Update state immediately
            setProductData((prev) => prev.filter((channel) => channel._id !== id));

            alert("Book deleted successfully ✅");
        } catch (error: any) {
            console.error("Error deleting slider:", error.response?.data || error.message);
            alert(error.response?.data?.message || "Failed to delete slider");
        }
    };


    const handleEdit = (id: number) => {
        // Handle edit logic
        console.log('Edit item with id:', id);
        navigate(`/youtube-channels/edit/${id}`);
    };

    const renderStatus = (status: string) => {
        if (status === 'active') {
            return (
                <span className="badge bg-success text-white fs-14 rounded-2">
                    Active
                </span>
            );
        }
        return null; // Return empty for inactive/empty status
    };

    const renderImage = (imageSrc: string, title: string) => {
        return (
            <img src={imageSrc} alt={title} width="100" />
        );
    };


    console.log("currentData",ProductData)
    return (
        <div className="main-container container-fluid">
            {/* PAGE HEADER START */}
            <div className="page-header">
                <h1 className="page-title">Product List</h1>
                <div>
                    <button
                        className="btn btn-primary"
                        onClick={() => navigate("/products/add")}
                        name="active"
                    >
                        <i className="icon-plus"></i> Add Product
                    </button>
                </div>
            </div>
            {/* PAGE HEADER END */}

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Product</th>
                                            <th>Category</th>
                                            <th>Stock</th>
                                            <th>Qty</th>
                                            <th>Price</th>
                                            <th>GST</th>
                                            <th>Shipping</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ProductData.length > 0 ? (
                                            ProductData.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td>
                                                        <div className="d-flex justify-content-start align-items-center product-name">
                                                            <div className="avatar-wrapper">
                                                                <div className="avatar avatar me-2 rounded-2 bg-label-secondary">
                                                                    <img
                                                                        src={item.featuredImage}
                                                                        alt={item.name}
                                                                        className="rounded-2"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="d-flex flex-column">
                                                                <h6 className="text-nowrap mb-0">
                                                                    {item.name}
                                                                </h6>
                                                                <p>
                                                                    <small className="text-muted text-truncate d-none d-sm-block">
                                                                        {item.shortDescription}
                                                                    </small>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{item.organize?.category}</td>
                                                    <td>
                                                        <label className="switch switch-square">
                                                            <input
                                                                type="checkbox"
                                                                className="switch-input"
                                                                defaultChecked={item.pricing?.inStock}
                                                            />
                                                            <span className="switch-toggle-slider">
                                                                <span
                                                                    className="switch-on"
                                                                    onClick={() =>
                                                                        console.log("status_stock", item._id)
                                                                    }
                                                                ></span>
                                                                <span
                                                                    className="switch-off"
                                                                    onClick={() =>
                                                                        console.log("status_stock", item._id)
                                                                    }
                                                                ></span>
                                                            </span>
                                                        </label>
                                                    </td>
                                                    <td>{item.inventory?.stock}</td>
                                                    <td>{item.pricing?.discountPrice || item.pricing?.basePrice}</td>
                                                    <td>{item.inventory?.gst}%</td>
                                                    <td>{item.inventory?.shippingCharges}</td>
                                                    <td>
                                                        <a
                                                            href="#!"
                                                            onClick={() =>
                                                                console.log("toggle_status", item._id)
                                                            }
                                                        >
                                                            <span className={`badge fs-14 rounded-2 ${
                                                                item.status === "active"
                                                                    ? "bg-success text-white"
                                                                    : "bg-danger text-white"
                                                            }`}>
                                                                {item.status}
                                                            </span>
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <div className="d-inline-block text-nowrap">
                                                            <button
                                                                onClick={() =>
                                                                    navigate(`/products/edit/${item._id}`)
                                                                }
                                                                className="btn bg-primary-transparent text-primary p-2 rounded-2 text-center fs-16 me-2"
                                                            >
                                                                <Edit size={16} />
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-icon"
                                                                onClick={() =>
                                                                    navigate(`/products/view/${item._id}`)
                                                                }
                                                            >
                                                                <i className="fe fe-eye"></i>
                                                            </button>
                                                            <a
                                                                href="#!"
                                                                className="bg-danger-transparent text-danger p-2 rounded-2 text-center fs-16"
                                                                // onClick={() => console.log("delete", item._id)}
                                                                onClick={() => handleDelete(item._id)}
                                                            >
                                                                <i className="fe fe-trash-2"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="text-center">
                                                    No products found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Simple Pagination */}
                                <div className="row">
                                    <div className="col-sm-12 col-md-5">
                                        <div className="dataTables_info">
                                            Showing {ProductData.length} entries
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ProductList;
;
